module.exports = __webpack_public_path__ + "img/bgc.7a646acc.png";